import { Typography } from "@packages/ds";
import styled from "styled-components";

import { Link as LinkDs } from "ds/Button";

export const Section = styled.section`
  width: 100%;
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const Link = styled(LinkDs)`
  font-weight: 600;
  font-size: 13px;
`;

export const BuildResources = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: var(--mode-bg-neutral-weakest);
  border-radius: 8px;
  padding: 24px 32px;
`;

export const Form = styled.form`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(20px, 280px));
`;

export const RamInputWrapper = styled.div`
  position: relative;
`;

export const Blank = styled(Typography.BodyText)<{
  gapSpace: number;
  disabled: boolean;
}>`
  position: absolute;
  left: ${({ gapSpace }) => `${gapSpace + 22}px`};
  top: 37px;
  display: block;
  z-index: 5;
  ${({ disabled }) =>
    disabled && `color: var(--mode-text-neutral-weakest-disabled);`}
`;
